import { render, staticRenderFns } from "./ShapeDivider.vue?vue&type=template&id=4baac50a"
import script from "./ShapeDivider.vue?vue&type=script&lang=js"
export * from "./ShapeDivider.vue?vue&type=script&lang=js"
import style0 from "./ShapeDivider.vue?vue&type=style&index=0&id=4baac50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports